import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EchantillonageComponent } from './echantillonage.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import {InputNumberModule} from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';
import { IsoComponent } from './iso/iso.component';
import { ComplexiteComponent } from './complexite/complexite.component';
import { OperateurComponent } from './operateur/operateur.component';
import { MultiSelectModule } from 'primeng/multiselect';


@NgModule({
  declarations: [EchantillonageComponent, IsoComponent, ComplexiteComponent, OperateurComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    PanelModule,
    TableModule,
    InputTextModule,
    DialogModule,
    ButtonModule,
    InputNumberModule,
    CalendarModule,
    MultiSelectModule
  ]
})
export class EchantillonageModule { }
